import React, {PureComponent} from 'react';
import Cookies from "universal-cookie";
import Snackbar from '@material-ui/core/Snackbar';
import Button from "@material-ui/core/Button/Button";
import axios from "axios";
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';

import './Settings.scss';
import {FETCH_URL} from "../../constants/ServerLinks";

export default class Settings extends PureComponent {

    constructor(props) {
        super(props);

        registerPlugin(FilePondPluginFileValidateType);
        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.participantId = this.cookies.get('p_id');
        this.roleId = this.cookies.get('role_id');
        this.roleName = this.cookies.get('role_name');
        this.origin = this.cookies.get('origin')
        this.country_name = this.cookies.get('country_name')
        this.world_skey = this.cookies.get('world_skey')
        this.state = {
            requestSent: false,
            snackMsg: 'Welcome!',
            snackOpen: false,
            snackType: 'snack',
            snackAutoHideDuration: null,
        };

        // https://stackoverflow.com/questions/52220537/how-to-use-filepond-in-vue-js-and-to-upload-files-using-axios
        this.pptServer = {
            url: this.fetchURL,
            process: (fieldName, file, metadata, load, error, progress, abort) => {

                // set data
                const formData = new FormData();
                formData.append('file', file, file.name);
                formData.append('role_id', this.roleId);
                formData.append('document_type', 'Presentation');

                // related to aborting the request
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();

                // the request itself
                axios({
                    method: 'post',
                    url: this.fetchURL + '/api/v1/documents/',
                    data: formData,
                    cancelToken: source.token,
                    onUploadProgress: (e) => {
                        // updating progress indicator
                        progress(e.lengthComputable, e.loaded, e.total);
                    }
                }).then(response => {
                    // passing the file id to FilePond
                    // console.group('Settings:uploadPPT');
                    // console.log(response);

                    if (response.data.success) {
                        load(response.data);
                    } else {
                        error(response.data.message);
                    }
                    // console.groupEnd();

                }).catch((thrown) => {
                    error(thrown.message);
                });

                // Setup abort interface
                return {
                    abort: () => {
                        source.cancel('Operation canceled by the user.');
                    }
                };
            },
        };

        this.polServer = {
            url: this.fetchURL,
            process: (fieldName, file, metadata, load, error, progress, abort) => {

                // set data
                const formData = new FormData();
                formData.append('file', file, file.name);
                formData.append('role_id', this.roleId);
                formData.append('document_type', 'Memo');

                // related to aborting the request
                const CancelToken = axios.CancelToken;
                const source = CancelToken.source();

                // the request itself
                axios({
                    method: 'post',
                    url: this.fetchURL + '/api/v1/documents/',
                    data: formData,
                    cancelToken: source.token,
                    onUploadProgress: (e) => {
                        // updating progress indicator
                        progress(e.lengthComputable, e.loaded, e.total);
                    }
                }).then(response => {
                    // passing the file id to FilePond
                    // console.group('Settings:uploadPol');
                    // console.log(response);

                    if (response.data.success) {
                        load(response.data);
                    } else {
                        error(response.data.message);
                    }
                    // console.groupEnd();

                }).catch((thrown) => {
                    error(thrown.message);
                });

                // Setup abort interface
                return {
                    abort: () => {
                        source.cancel('Operation canceled by the user.');
                    }
                };
            },
        };
    }

    logout = (e) => {
        e.preventDefault();
        if(this.origin){
            if(this.origin === "CLSG"){
                this.setState({snackOpen: true, snackMsg: "Are you sure you want to return to your CLSG account?"});
            }
            if(this.origin === "NOT_CLSG"){
                this.setState({snackOpen: true, snackMsg: "Are you sure you want to logout?"});
            }
            
        }
    };

    logoutYes = () => {

        this.setState({requestSent: true});

        axios.delete(this.fetchURL + '/api/v1/roles/', {
            params: {
                participant_id: this.participantId,
                role_id: this.roleId,
                country_name: this.country_name,
                world_skey: this.world_skey
            }
        })
            .then((response) => {
                // console.log(response.data);
                this.setState({requestSent: false});

                if (response.data.success) {
                    this.setState({
                        snackOpen: true,
                        snackMsg: `Logout successful!`,
                        snackType: 'snack-success',
                        snackAutoHideDuration: 5000,
                    });
                    if(this.origin){
                        if(this.origin === "CLSG"){
                            this.cookies.remove('role_id');
                            this.cookies.remove('role_name');
                            this.cookies.remove('country_id');
                            this.cookies.remove('country_name');
                            this.cookies.remove('origin');
                            this.setState({snackOpen: false});
                            window.close();        
                        }
                        if(this.origin === "NOT_CLSG"){
                            this.cookies.remove('role_id');
                            this.cookies.remove('role_name');
                            this.cookies.remove('country_id');
                            this.cookies.remove('country_name');
                            this.cookies.remove('origin');
                            this.cookies.remove('uid', {path: "/"});
                            this.cookies.remove('token');
                            this.cookies.remove('origin', {path: "/"});
                            this.setState({snackOpen: false});
                            // window.location.replace(`/student/${this.world_skey}/${this.p_id}/${this.s_name}`);
                            window.location.replace(`/`);
                        }
                    }

                } else {
                    this.setState({
                        snackOpen: true,
                        snackMsg: response.data.message,
                        snackType: 'snack-error',
                        snackAutoHideDuration: 5000,
                    });
                }
            })
            .catch((error) => {
                console.log(error.response);
                this.setState({
                    requestSent: false,
                    snackOpen: true,
                    snackMsg: 'Something went wrong. Please try again later.',
                    snackType: 'snack-error',
                    snackAutoHideDuration: 5000,
                });
            });
    };

    handleClose = () => {
        this.setState({snackOpen: false});
    };

    render() {
        // const polFileType = [
        //     'text/plain',
        //     'application/pdf',
        //     'application/doc',
        //     'application/msword',
        //     'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // ];
        //
        // const pptFileType = [
        //     'application/pdf',
        //     'application/vnd.ms-powerpoint',
        //     'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        // ];
        //
        // // allows mapping of file types to label values ( how type is shown in error label )
        // // "null" means don't show
        // const polFileMap = {
        //     'text/plain': '.txt',
        //     'application/pdf': '.pdf',
        //     'application/doc': '.doc',
        //     'application/msword': '.doc',
        //     'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
        // };
        //
        // const pptFileMap = {
        //     'application/pdf': '.pdf',
        //     'application/vnd.ms-powerpoint': '.ppt',
        //     'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
        // };
        //
        // // the label to show, {placeholders} are automatically replaced
        // const errorMsg = 'Expects {allButLastType} or {lastType}';

        return (
            <div className={`dash__wrap ${this.props.display === "show" ? "active" : "hidden"}`}>
                <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                    open={this.state.snackOpen}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    className="snack"
                    autoHideDuration={this.state.snackAutoHideDuration}
                    onClose={this.handleClose}
                    message={<span id="message-id">{this.state.snackMsg}</span>}
                    action={this.state.snackType === 'snack' ? [
                            <Button key="yes" color="secondary" onClick={this.logoutYes}>
                                Yes
                            </Button>,
                            <Button key="no" color="inherit" onClick={this.handleClose}>
                                No
                            </Button>,]
                        :
                        []
                    }
                />

                {/*{this.props.isGameComplete && this.roleName === 'Prime Minister' &&*/}
                {/*<div className="uploadFiles p4">*/}
                    {/*<h4>Upload your policy memo here:</h4>*/}
                    {/*<br/>*/}
                    {/*<FilePond id="memoUploader" server={this.polServer}*/}
                              {/*allowRevert={false}*/}
                              {/*instantUpload={false}*/}
                              {/*acceptedFileTypes={polFileType}*/}
                              {/*fileValidateTypeLabelExpectedTypesMap={polFileMap}*/}
                              {/*fileValidateTypeLabelExpectedTypes={errorMsg}/>*/}
                    {/*<br/>*/}
                    {/*<h4>Upload your presentation here:</h4>*/}
                    {/*<br/>*/}
                    {/*<FilePond id="memoUploader" server={this.pptServer}*/}
                              {/*allowRevert={false}*/}
                              {/*instantUpload={false}*/}
                              {/*acceptedFileTypes={pptFileType}*/}
                              {/*fileValidateTypeLabelExpectedTypesMap={pptFileMap}*/}
                              {/*fileValidateTypeLabelExpectedTypes={errorMsg}/>*/}
                {/*</div>*/}
                {/*}*/}

                <form method="post"
                      onSubmit={e => this.logout(e)}>
                    <h5>Do you want to logout?</h5>
                    <button type="submit"
                            className="loginBtn button"
                            disabled={this.state.requestSent ? 'disabled' : ''}>
                        {this.state.requestSent ? 'Logging out . . .' : 'Logout'}
                    </button>
                </form>

            </div>
        )
    }
}
